import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapisbleSectionComponent } from './collapisble-section.component';
import {MatIconModule} from '@angular/material/icon';



@NgModule({
  declarations: [CollapisbleSectionComponent],
  exports: [
    CollapisbleSectionComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class CollapisbleSectionModule { }
